import { LNGS_NAMESPACE_SEGMENT } from '@ingenico/util-i18n-config';
import { capitalize, toNumber, toString } from 'lodash-es';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import type { DashboardRowContentProps, UseDashboardRowContentReturn } from './DashboardRowContent.model';
import { getSvgNameFromEntity, openNewTabAccordingEntity } from './DashboardRowContent.util';
import { useProvisioningSectionRoutePrefix } from '../../hooks/useProvisioningSectionRoutePrefix.hook';

export function useDashboardRowContent({ dashboardRowData }: DashboardRowContentProps): UseDashboardRowContentReturn {
  const { merchantId } = useParams();
  const { t } = useTranslation(Object.values(LNGS_NAMESPACE_SEGMENT));
  const iconName = getSvgNameFromEntity(dashboardRowData);
  const { shouldShowViewButton = true, isError, numberOfEntities, entity } = dashboardRowData;
  const hasInactiveEntities = toNumber(numberOfEntities) > 0;
  const getTitle = useMemo(() => {
    return capitalize(
      t(`dashboardSection.title.${entity}`, {
        ns: LNGS_NAMESPACE_SEGMENT.MERCHANT,
      }),
    );
  }, [entity, t]);

  const getCount = useMemo(() => {
    if (isError) {
      return '';
    } else if (numberOfEntities && numberOfEntities > 0) {
      return toString(numberOfEntities);
    } else {
      return '0';
    }
  }, [isError, numberOfEntities]);

  const isDisabled = useMemo(() => isError || !numberOfEntities, [isError, numberOfEntities]);

  const provisioningRoutePrefix = useProvisioningSectionRoutePrefix();

  function openNewTab() {
    openNewTabAccordingEntity(dashboardRowData, toString(merchantId), provisioningRoutePrefix);
  }

  return {
    t,
    isError,
    openNewTab,
    isDisabled,
    getTitle,
    getCount,
    hasInactiveEntities,
    shouldShowViewButton,
    iconName,
  };
}
